// Angular
import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
// Service
import { BroadcastService } from '@cv-invision/core';
import { SchemasService } from '../services/schemas.service';
import { ViewsService } from '../services/views.service';
import { Lightbox } from 'ngx-lightbox';
// Model
import { BroadcastEventModel } from '@cv-invision/core';
import { ROOM_POSITION } from '../sections-review/models/cvds/v3.3/room.layout';
import { CHANGE_SKETCH_IMAGE } from '../floating-sketch/floating-sketch.component';
// Other
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

// Deprecated
export const EVENT_MENU_SELECTED_LEVEL = 'eventMenuSelectedLevel';

@Component({
	selector: 'cv-inline-sketch',
	encapsulation: ViewEncapsulation.None,
	templateUrl: 'inline-sketch.component.html',
	styleUrls: ['inline-sketch.component.scss']
})
export class InlineSketchComponent implements OnInit, OnDestroy {
	// Status of the Sketch
	public levelName = '';
	// List of Selected Sketch
	public selectedSketch = [];
	public selectedSectionPath = '';
	// Album
	public album = [];
	// Broadcast instance
	private atComponentDestroy = new Subject();

	constructor(
		private broadcastService: BroadcastService,
		private schemasS: SchemasService,
		private lightbox: Lightbox,
		private viewsServices: ViewsService) {
	}

	// Information from the Order and Document
	get photos(): any {
		return this.viewsServices.photos;
	}

	// All Photo Selected
	get photosSelected(): any {
		return this.viewsServices.photosSelected;
	}

	// To traverse the document
	get document(): any {
		return this.viewsServices.document;
	}

	// To get All Levels
	get levels(): any {
		return this.viewsServices.levels;
	}

	/**
	 * Initialize the Sketch with the First Level Selected
	 */
	async ngOnInit(): Promise<void> {

		this.loadSketch();

		// Listen to select an Item
		this.broadcastService
			.onEvent(CHANGE_SKETCH_IMAGE)
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe((e: BroadcastEventModel) => {
				const {event: {data}} = e;
				if (data.removeSketch) {
					this.selectedSectionPath = '';
				} else {
					const roomPosition = (data.room && data.room.position && data.room.position.toLowerCase()) || '';
					const levelPath = (data.level && data.level._Path) || '';
					if (roomPosition === ROOM_POSITION.INTERIOR.toLowerCase()) {
						if (this.selectedSectionPath !== levelPath) {
							this.selectedSectionPath = levelPath;
						}
					} else {
						this.selectedSectionPath = '';
					}
				}
			});
	}

	/**
	 * Open Current Photo but keep the Album
	 * @param data
	 */
	public openGallery(data: any): void {
		if (data.photo) {
			const image = {
				src: data.photo.path,
				caption: '',
				thumb: ''
			};
			this.lightbox.open([image], 0);
		}
	}

	/**
	 * * Mark or not the Sketch Photo
	 * @param event HTML Input Change Event
	 * @param image from the array of images
	 */
	public onCheckSketch(event: any, image: any): void {
		const photoIndex = this.photosSelected.indexOf(image.id);
		if (photoIndex > -1) {
			this.photosSelected.splice(photoIndex, 1);
		} else {
			this.photosSelected.push(image.id);
		}
	}

	/**
	 * Return if the image is on the photo selected method
	 * @param image from the array of images
	 */
	public isSketchSelected(image: any): boolean {
		return this.photosSelected.indexOf(image.id) >= 0;
	}

	ngOnDestroy(): void {
		this.atComponentDestroy.next({});
		this.atComponentDestroy.unsubscribe();
	}

	/**
	 * Load the Menu and listen for changes if necessary
	 * @private
	 */
	private loadSketch(): void {
		this.album = [];
		this.selectedSketch = [];
		const sketchFiles = this.photos.filter((photo: any) => photo.metadata && photo.metadata.type === 'SKETCH') || [];

		const groupBy = (xs: any, key: any) => {
			return xs.reduce((rv: any, x: any) => {
				(rv[x[key]] = rv[x[key]] || []).push(x);
				return rv;
			}, {});
		};

		const groupedByPath = sketchFiles.reduce((rv: any, x: any) => {
			(rv[x['refJsonPath']] = rv[x['refJsonPath']] || []).push(x);
			return rv;
		}, {});

		for (const key in groupedByPath) {
			if (Object.prototype.hasOwnProperty.call(groupedByPath, key)) {
				const group = groupedByPath[key];
				let matchToPush = group[0];

				const sketchFilesGLA =
					group.filter(photo => photo.metadata.imageType === 'GLA' && (photo.refJsonPath && matchToPush.refJsonPath)) || [];

				if (sketchFilesGLA.length > 0) {
					matchToPush = sketchFilesGLA[0];
				}

				const allLevels = this.levels && this.levels.length > 0 ? this.levels.flat() : [];
				const level = allLevels.find((l: any) => l._Path === matchToPush.refJsonPath);
				if (level) {
					this.album.push({
						src: matchToPush.path,
						caption: '',
						thumb: ''
					});

					matchToPush.levelName = level.levelName;

					this.selectedSketch.push(matchToPush);
				}
			}
		}
	}
}
